<template>
  <thead :ref="theadRef" v-bind:class="{'sticky': isTableVisible(scrollOffsetY, tablePosition)}">
    <tr :class="namespace + 'HeadTr'" v-bind:style="getTableHeadRowStyle">
      <template v-for="(column, columnIndex) in columns">
        <template v-if="customTableHeadTemplate">
          <slot :name="(fixed ? 'customHeaderDataFixed' : 'customHeaderData')"
                :column="column"
                :columnIndex="columnIndex">
          </slot>
        </template>
        <template v-else>
          <template v-if="isColumnCanBeDisplayed(column)">
            <th v-on:mouseenter="onThHover(column.field, true)"
                v-on:mouseleave="onThHover(column.field, false)"
                v-bind:class="getThClasses(column)"
                v-bind:style="{'min-width': column.width, 'min-height': '25px'}"
                :colspan="calculateColSpan(column.field, column.isCompareColumn)">

              <div class="column-header-wrapper">
                <span v-visible="((isColumnHovered(column.field) || isColumnFixed(column.field)) && column.canBeFixed)"
                      class="pin-fixed-column"
                      @click="makeColumnFixed(column.field)"
                      v-bind:class="{'fixed': isColumnFixed(column.field)}"></span>

                <span @click="applySorting(column, columnIndex)">{{column.label}} {{column.sign}}</span>

                <span class="sorting" v-visible="column.sort === true && (isColumnHovered(column.field) || getSortedColumn == column.field)">
                    <i class="sorting-top"
                       @click="applySorting(column, columnIndex)"
                       v-bind:class="{'active': getSortedColumn == column.field && getSortedColumnDirection == 'ASC'}"
                       v-show="getSortedColumn != column.field || (getSortedColumn == column.field && getSortedColumnDirection == 'ASC')"
                    ></i>

                   <i class="sorting-bottom"
                      @click="applySorting(column, columnIndex)"
                      v-bind:class="{'active': getSortedColumn == column.field && getSortedColumnDirection == 'DESC'}"
                      v-show="getSortedColumn != column.field || (getSortedColumn == column.field && getSortedColumnDirection == 'DESC')"
                   ></i>

                </span>
              </div>

              <div v-if="datesComparisonEnabled && (column.isMetricValue + column.isCompareColumn) && data.length"
                   class="column-dates-comparison-wrapper"
                   @click="showDatesComparison(column)">
                <i v-bind:class="{'active': isFieldShowDatesComparison(column.field)}"></i>
              </div>

            </th>
          </template>
          <template v-if="column.dynamicField && isSellingPartnersExists && customFieldName.includes(column.originalField)">
            <template v-for="partnerName in getPartners">
              <th>
                {{partnerName}} {{column.label}}
              </th>
            </template>
          </template>
        </template>
      </template>
    </tr>
    <tr v-if="datesComparisonEnabled && data.length" class="datesRangeComparisonHeader" :id="namespace + 'datesRangeComparisonColumn'">
      <template v-for="(column, columnIndex) in columns" v-if="isColumnCanBeDisplayed(column)">
        <template v-if="customTableHeadDatesComparisonTemplate">
          <slot :name="(fixed ? 'customHeaderDatesComparisonDataFixed' : 'customHeaderDatesComparisonData')"
                :column="column"
                :columnIndex="columnIndex">
          </slot>
        </template>
        <template v-else>
          <template v-if="isFieldShowDatesComparison(column.field)">
            <th class="small">{{dateRangeA}}</th>
            <th class="small">{{dateRangeB}}</th>
            <template v-if="!column.isCompareColumn">
              <th class="small">Change</th>
              <th class="small">Change (%)</th>
            </template>
          </template>
          <template v-else>
            <th></th>
          </template>
        </template>
      </template>
    </tr>
    <tr v-if="isSellingPartnersExists && data.length">
      <template v-if="column.dynamicField && customFieldName.includes(column.fieldNameOriginal)" v-for="(column, columnIndex) in columns">
        <template v-if="customTableHeadSellingPartnersTemplate">
          <slot :name="(fixed ? 'customHeaderSellingPartnersDataFixed' : 'customHeaderSellingPartnersData')"
                :column="column"
                :columnIndex="columnIndex">
          </slot>
        </template>
        <template v-else>
          <template v-for="partnerName in sellingPartnersList">
            <th></th>
          </template>
        </template>
      </template>
    </tr>
  </thead>

</template>

<script>

  import '@/style/reports/base_table_style.scss';
  import tableCommonMixin from '@/components/reports/mixins/tableCommonMixin';

  import fixTableMixin from '@/components/reports/mixins/fixTableMixin';
  import sellingPartnerMixin from '@/components/reports/mixins/sellingPartnerMixin';

  import sortTableMixin from '@/components/reports/mixins/sortTableMixin';

  import hoverTableMixin from '@/components/reports/mixins/hoverTableMixin';
  import datesComparisonTableMixin from '@/components/reports/mixins/datesComparisonTableMixin';

  export default {
    name: "table-head",
    components: {

    },
    mixins: [
      tableCommonMixin,
      fixTableMixin,
      sortTableMixin,
      hoverTableMixin,
      datesComparisonTableMixin,
      sellingPartnerMixin
    ],
    props: {
      data: {
        type: Array,
        required: true
      },
      columns: {
        type: Array,
        required: true
      },
      namespace: {
        type: String,
        required: true
      },
      tableContainerId: {
        type: String,
        required: true
      },
      customTableHeadTemplate: {
        type: Object,
        required: false
      },
      customTableHeadDatesComparisonTemplate: {
        type: Object,
        required: false
      },
      customTableHeadSellingPartnersTemplate: {
        type: Object,
        required: false
      },
      fixed: {
        type: Boolean,
        default: false,
        required: false
      },
    },
    data(){
      return {
        deviceTopOffset: this.$md.mobile() !== null ? 0 : 60,
        interval: null,
        customFieldName: ['soldClicks', 'revenue', 'rpc'],
        theadRef: this.fixed ? 'fixedThead' : 'thead',
        tablePosition: {offsetTop: null, clientHeight: null},
      }
    },
    mounted(){
      let that = this;

      let table = this.$parent.$refs[this.tableContainerId];

      if (table !== undefined)
      {
        this.$nextTick(function(){
          that.tablePosition.offsetTop = table.offsetTop;
          that.tablePosition.clientHeight = table.clientHeight;
        });
      }
    },
    computed: {
      scrollOffsetY: function(){
        let vm = this;
        let scrollOffsetY = this.$store.getters.getScrollOffsetY;

        window.requestAnimationFrame(function(){
          if ((scrollOffsetY > vm.tablePosition.offsetTop))
          {
            let offset = scrollOffsetY - vm.tablePosition.offsetTop - vm.deviceTopOffset;
            vm.$refs[vm.theadRef].style.transform = 'translateY(' + offset + 'px)';
          }
          else
          {
            vm.$refs[vm.theadRef].style.transform = 'translateY(0)';
          }
        });

        return scrollOffsetY;
      },
      getTableHeadRowStyle: function(){
        let style = {};

        if (this.fixed)
        {
          let rowRef = document.querySelector('.' + this.namespace + 'HeadTr');

          if (rowRef != undefined && rowRef !== null)
          {
            style['height'] = rowRef.clientHeight + 'px';
          }
        }

        return style;
      },
    },
    methods: {
      isColumnCanBeDisplayed(column){
        if (this.fixed)
        {
          return column.visible && this.isColumnFixed(column.field) && this.isAnyFixedColumnsExist;
        }
        else
        {
          return column.visible && !this.isColumnFixed(column.field);
        }
      },
      getThClasses(column){
        let classes = [column.field];

        if (this.datesComparisonEnabled)
        {
          classes.push('align-right');
        }

        if (this.fixed)
        {
          if (!(this.isColumnFixed(column.field) && this.isAnyFixedColumnsExist))
          {
            classes.push('hidden');
          }
        }
        else
        {
          if (this.isColumnFixed(column.field) && this.isAnyFixedColumnsExist)
          {
            classes.push('hidden');
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .pin-fixed-column {
    width: 11px;
    height: 11px;
    margin-left: 2px;
    margin-right: 5px;
    background-image: url('/static/img/icon-pin.svg');
    background-repeat: no-repeat;
    background-position: left center;
    background-size: contain;

    &.fixed {
      background-image: url('/static/img/icon-pin-fixed.svg');
    }
  }

  .sticky-header-column {
    position: relative;
    z-index: 2;
    transition: 0.3s;
  }

  .table {
    & > thead {
      will-change: transform;
      -webkit-transform: translateZ(0);
      transition: all .02s ease;

      &.sticky {
        position: sticky;
        will-change: transform;

        & > * {
          -webkit-transform: translateZ(0);
        }
      }

      &.stickyHeader {
        position: fixed;
        top: 0;
        transition: all .5s ease-in-out;
      }

      & > tr {
        text-align: left;

        & > th {
          padding: 5px 0 5px 5px;
          border: 1px solid $border-color;
          cursor: pointer;
          height: 40px;

          background: -moz-linear-gradient(top, #fbfbfb 5%, #ededed 100%); /* FF3.6-15 */
          background: -webkit-linear-gradient(top, #fbfbfb 5%, #ededed 100%); /* Chrome10-25,Safari5.1-6 */
          background: linear-gradient(to bottom, #fbfbfb 5%, #ededed 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fbfbfb', endColorstr='#ededed', GradientType=0); /* IE6-9 */
          background-repeat: no-repeat;

          & > div {
            display: flex;
            align-content: center;
            align-self: center;
            //align-items: baseline;
          }

          & > * {
            font-family: $font-stack;
            font-size: 13px;
          }

          &:hover {
            background: #e7e7e7;
          }

          & + .hidden {
            display: none;
          }

          & + .small {
            min-width: 100px;
            font-size: 12px;
            font-weight: bold;
            padding: 5px 10px 5px 10px;
            text-align: left;
          }

          &.align-right {
            vertical-align: top;
          }
        }

        & > th:first-child {
          border-left: 0;
        }

        & > th:last-child {
          border-right: 0;
        }

        &.datesRangeComparisonHeader {
          & > th {
            background: #f3f3f3;
            height: 40px;
          }
        }
      }
    }
  }

  @include mobile-only {
    .table > thead {

      &.sticky {
        position: sticky;
        transition: none;

        & > * {
          -webkit-transform: translateZ(0);
          transform: translate3d(0px,0px,0px);
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/reports/common/table/TableHead.vue